package pl.nickers.match3.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import pl.nickers.match3.TutorialOverlayUi
import pl.nickers.match3.ecs.TutorialStep

/**
 * Renders the level-1 tutorial caption + "Skip" affordance (issue #110, F16.1
 * first-level slice). The board highlight itself is drawn inside [GameGrid], since
 * only it knows the cell geometry — this composable only renders the copy bubble and,
 * for step 2, a full-screen tap catcher that dismisses the overlay ("Dismiss on tap").
 */
@Composable
internal fun TutorialOverlay(
    tutorial: TutorialOverlayUi,
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
) {
    when (tutorial.step) {
        TutorialStep.SWAP_HINT -> {
            Box(modifier.fillMaxSize()) {
                TutorialCaption(
                    message = tutorial.message,
                    onSkip = onDismiss,
                    modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = 96.dp),
                )
            }
        }
        TutorialStep.POINT_AT_GOALS -> {
            Box(
                modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.45f))
                    .pointerInput(Unit) { detectTapGestures { onDismiss() } },
            ) {
                TutorialCaption(
                    message = tutorial.message,
                    onSkip = onDismiss,
                    modifier = Modifier.align(Alignment.TopCenter).padding(top = 72.dp),
                )
            }
        }
    }
}

@Composable
private fun TutorialCaption(message: String, onSkip: () -> Unit, modifier: Modifier = Modifier) {
    Column(
        modifier = modifier
            .padding(horizontal = 24.dp)
            .background(MaterialTheme.colorScheme.surface.copy(alpha = 0.95f), RoundedCornerShape(12.dp))
            .padding(16.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Text(text = message, color = MaterialTheme.colorScheme.onSurface)
        Spacer(Modifier.height(8.dp))
        Row(horizontalArrangement = Arrangement.End, modifier = Modifier.fillMaxWidth()) {
            TextButton(onClick = onSkip) { Text("Skip") }
        }
    }
}
